import Publications1 from './../images/works/Publications/Cover_February-2015.jpg'
import Publications2 from './../images/works/Publications/Grab-Your-Popcorn-I---Pretty-Woman.jpg'

const Publications = [Publications1, Publications2]

export default Publications